import { find } from 'lodash';

class OptionsFormController {
    constructor($timeout, $state, optionsService, imgix, messageService, access, currentPropertyService, integrationApiService) {
        this.$timeout = $timeout;
        this.$state = $state;
        this.optionsService = optionsService;
        this.imgix = imgix;
        this.messageService = messageService;
        this.access = access;
        this.currentPropertyService = currentPropertyService;
        this.integrationApiService = integrationApiService;
    }

    $onInit () {
        this.messageService.clear();

        this.isAdmin = this.access.check('admin');
        this.hasIntegration = !!this.currentPropertyService.get().integration;

        if (!this.option.option_group || !this.option.option_group.length) {
            this.option.option_group = [{ 'option_id': undefined, 'option_type': undefined }, { 'option_id': undefined, 'option_type': undefined }];
        }
        this.option.selections = this.option.selections || 1;

        this.imgix.reload();

        if (this.hasIntegration) {
            return this.integrationApiService.integrationPackageCollect(this.currentPropertyService.get().id).then(response => {
                this.importedPackages = response.filter(spaday => spaday.options && Object.keys(spaday.options).length > 0);
            }).then(() => {
                if (this.option.integration_owner_identity) {
                    this.loadOptions();
                }
            });
        }
    }

    deslug (input) {
        if (input) {
            return input.split('\\')[1].replace(/([A-Z])/g, ' $1').trim();
        }
    }

    addOption () {
        this.option.option_group.push({ 'option_id': undefined, 'option_type': undefined });
    }

    optionList (type) {
        switch (type) {
            case 'App\\Treatment':
                return this.treatments;
        }
    }

    finditem (option) {
        switch (option.option_type) {
            case 'App\\Treatment':
                return find(this.treatments, { id: option.option_id });
        }
    }

    clearInputs (option) {
        option.override_name = '';
        option.override_description = '';
        option.override_image = '';
    }

    removeOption (key) {
        this.option.option_group.splice(key, 1);

        const maxLength = this.option.option_group.length - 1;
        if (this.option.selections > maxLength) {
            this.option.selections = maxLength;
        }
    }

    loadOptions () {
        this.optionsLoading = true;
        return this.integrationApiService.integrationSinglePackageCollect(this.currentPropertyService.get().id, this.option.integration_owner_identity).then(response => {
            this.importedOptions = this.sortOptions(response.options);
            this.optionsLoading = false;
        });
    }

    sortOptions (optionList) {
        if (!optionList) {
            return [{
                integration_identity: null,
                name: `None available`,
                disabled: true
            }];
        }

        return Object.values(optionList).map(optionGroup => {
            if (optionGroup.selections === 1) {
                return {
                    integration_identity: optionGroup.integration_identity,
                    name: `Choose ${optionGroup.selections}; ` + optionGroup.options.map(option => option.name).join('/').trim('/')
                };
            }
        }).filter(Boolean);
    }

    onSave () {
        for (let i in this.option.option_group) {
            if (this.option.option_group[i].option) {

                this.option.option_group[i].option_id = this.option.option_group[i].option.id;
                this.option.option_group[i].option = undefined;
            }

            if (!this.option.option_group[i].upgradeable) {
                delete (this.option.option_group[i].upgrade_name);
                delete (this.option.option_group[i].upgrade_description);
                delete (this.option.option_group[i].upgrade_value);
                delete (this.option.option_group[i].upgrade_image_path);
                delete (this.option.option_group[i].upgrade_image_url);
            }
        }

        delete (this.option.grouped_visibility);

        return this.optionsService.save(this.option)
            .then(response => {
                let name = this.option.name || 'unnamed';
                if (this.option.id) {
                    this.messageService.success(`The option group <strong>${name}</strong> was successfully updated! Please update the exclusion rules if necessary.`, [`app.admin.option-edit({ option : ${this.option.id}})`, `Option`]);
                    this.$state.go('app.admin.options');
                } else {
                    this.messageService.success(`The option group <strong>${name}</strong> was successfully created. Please create exclusion rules.`);
                    this.option = response;
                    this.$state.go('app.admin.option-edit', { option: this.option.id, tab: 'visibility' });
                }
            })
            .catch((error) => {
                error.data = error.data.original || error.data;
        this.form.$api.setErrors(error.data);

                let sourceElement = Object.keys(error.data);
                let verb = 'created';
                if (this.option.id) {
                    verb = 'updated';
                }
                if (sourceElement.length > 0) {
                    let errors = '';
                    for (let element of sourceElement) {
                        errors += `<li>${this.messageService.formatError(element, error.data[element])}</li>`;
                    }
                    this.messageService.failure(`The option <strong>${this.option.name}</strong> could not be successfully ${verb}: <ul>${errors}</ul>`);
                } else {
                    this.messageService.failure(`The option <strong>${this.option.name}</strong> could not be successfully ${verb}: ${error.statusText}`);
                }
                this.messageService.push();
            });
    }

    getOptions () {
        return this.option.option_group;
    }

    setSelections (number) {
        this.option.selections = number;
    }

    hasSelections (number) {
        return this.option.selections === number;
    }
}

OptionsFormController.$inject = ['$timeout', '$state', 'optionsService', 'imgix', 'messageService', 'access', 'currentPropertyService', 'integrationApiService'];

export default OptionsFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/options.form.controller.js